import {Fragment, ReactElement} from "react";
import {TableCell, TableRow} from "@mui/material";
import {DeviceType, UserStatus} from "@/api";
import {FormattedMessage, defineMessages} from "react-intl";
import {Link} from "../widgets";
import FormattedRegistrationTime from "../FormattedRegistrationTime";
import {CompactNumber} from "./widgets";
import {DomainLocationStatusQuery} from "./queries.generated";

type DeviceInfo = UserStatus | DomainLocationStatusQuery["domainStatus"]["locations"][number]["statuses"][number];

type Props = {
    deviceInfo: DeviceInfo;
    domainId: number;
    hideNumberBottomBorder?: boolean;
    hideNumber?: boolean;
};

const DEVICE_TYPE_MESSAGES = defineMessages<DeviceType>({
    CLIENT: {id: "DeviceType.CLIENT", defaultMessage: "Client"},
    LINKED: {id: "DeviceType.LINKED", defaultMessage: "Linked"},
    PROVISIONED: {id: "DeviceType.PROVISIONED", defaultMessage: "Provisioned"},
    THIRDPARTY: {id: "DeviceType.THIRDPARTY", defaultMessage: "Third-party"},
});

export default ({deviceInfo, domainId, hideNumberBottomBorder, hideNumber}: Props) => {
    function formattedDescription(): string | ReactElement<any> {
        switch (deviceInfo.deviceType) {
            case DeviceType.Linked:
                return (
                    <Fragment>
                        <span>
                            <FormattedMessage id="linked_to" defaultMessage="Linked to" />{" "}
                        </span>
                        <Link to={`/domains/${domainId}/users/${deviceInfo.linkedUserId}/devices`}>
                            <CompactNumber e164={deviceInfo.linkedE164} shortNumber={deviceInfo.linkedShortNumber} />
                        </Link>
                    </Fragment>
                );

            case DeviceType.Provisioned:
                return (
                    <Fragment>
                        <span>MAC: </span>
                        <span>{deviceInfo.deviceDescription}</span>
                    </Fragment>
                );

            case DeviceType.Client:
            case DeviceType.Thirdparty:
                return deviceInfo.deviceDescription;
        }
    }

    return (
        <TableRow>
            <TableCell style={{borderBottomWidth: hideNumberBottomBorder ? 0 : 1}}>
                {!hideNumber && (
                    <Link to={`/domains/${domainId}/users/${deviceInfo.userId}/devices`}>
                        <CompactNumber shortNumber={deviceInfo.shortNumber} e164={deviceInfo.e164} />
                    </Link>
                )}
            </TableCell>
            <TableCell>{deviceInfo.ipAddress}</TableCell>
            <TableCell>
                <FormattedMessage {...DEVICE_TYPE_MESSAGES[deviceInfo.deviceType]} />
            </TableCell>
            <TableCell>{formattedDescription()}</TableCell>
            <TableCell>
                <FormattedRegistrationTime
                    registrationTime={deviceInfo.registrationTime}
                    expirationTime={deviceInfo.registrationExpireTime}
                    clientInfo={deviceInfo.clientInfo}
                />
            </TableCell>
        </TableRow>
    );
};
